import {
  WALLBOARDS,
  LOADING,
  SUCCESS_VIEWS,
  SUCCESS_SETTING,
  CREATE_SETTING,
  DELETE_SETTING
} from './WallboardsActions';

const INITIAL_STATE = {
  loading: false,
  boards: [],
  views: [],
  page: 0,
  total: 0,
  setting: {
    rotationInterval: 30,
    enabledCharts: {
      overview: true,
      cfd: true,
      ctsp: true,
      ctb: true,
      cth: true,
      cta: true,
      trc: true,
      th: true,
      fe: true,
      ddp: true,
      mc: true,
      mct: true
    }
  }
};

const WallboardsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WALLBOARDS: {
      return {
        ...state,
        loading: false,
        boards: action.data.results,
        page: action.data.page,
        total: action.data.total
      };
    }
    case LOADING: {
      return {
        ...state,
        loading: action.val
      };
    }
    case SUCCESS_VIEWS: {
      return {
        ...state,
        views: action.views
      };
    }
    case SUCCESS_SETTING: {
      return { ...state, setting: action.setting, isLoading: false };
    }
    case CREATE_SETTING: {
      return {
        ...state,
        loading: false
      };
    }
    case DELETE_SETTING: {
      return {
        ...state,
        loading: false
      };
    }
  }

  return state;
};

export default WallboardsReducer;
